import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { X, ShoppingCart } from 'lucide-react';

const CartPopup = ({ isOpen, onClose }) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div 
      data-testid="cart-popup-overlay"
      className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center"
      onClick={onClose}
    >
      <div 
        data-testid="cart-popup"
        className="bg-white rounded-lg shadow-2xl p-8 mx-4 max-w-sm w-full text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-end mb-4">
          <button 
            data-testid="cart-popup-close"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-[#e21b1b]/10 rounded-full flex items-center justify-center">
            <ShoppingCart className="w-8 h-8 text-[#e21b1b]" />
          </div>
        </div>
        
        <p className="font-roboto text-gray-700 text-lg">
          {t('cart.popup')}
        </p>
      </div>
    </div>
  );
};

export default CartPopup;
